
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class WeChat extends Vue {
  summary: string = ''

  get summaryLength() {
    return this.summary.length
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  async onSubmit() {
    try {
      if (!this.summary) {
        this.$msg('简介不能为空')
        return
      }

      this.summary = this.summary.replace(/\n{3,}/g, '\n\n').trim()

      await this.UserStore.onUpdateUserInfo({
        id: this.UserStore.UserInfo.id,
        summary: this.summary
      })

      this.$msg('保存成功', 'success')

      return true
    } catch (error) {}
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
